import { useState } from "react"
import Restaurar from "../../page/login/Restaurar"
import RestPrivateAntesala from "../../../helpers/RestPrivateApi"
import Alerts from "../../components/Alerts/Alerts"
import { useNavigate } from "react-router-dom"

const RestaurarController = () => {
    const navigation = useNavigate();
    const [loading, setLoading] = useState(false)
    const [form, setForm] = useState({
        email: ""
    })

    const onClick = async (e) => {
        switch (e.target.name) {
            case 'enviar':{

                setLoading(true);

                // Validación frontend
                if (!form.email || form.email.trim() === "") {
                  setLoading(false);
                  return Alerts({
                    msg: "Error",
                    title: "El email es obligatorio",
                    code: "400",
                    type: "error",
                  });
                }

                // Validación de formato de email
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(form.email)) {
                  setLoading(false);
                  return Alerts({
                    msg: "Error",
                    title: "Ingresa un email válido",
                    code: "400",
                    type: "error",
                  });
                }

                let dataForm = new FormData();
                dataForm.append("email", form.email);

                const response = await RestPrivateAntesala({
                    method: "post",
                    url: "/auth/recuperar-contraseña",
                    formData: dataForm,
                    setLoading: setLoading,
                  });

                  if (response.status == 201 || response.status == 200) {
                    Alerts({
                      msg: "Éxito",
                      title: response.data.msg || "Se envió un correo para recuperar la contraseña",
                      code: "200",
                      type: "success",
                    });

                    return navigation("/login");
                  } else {
                    // Manejo mejorado de errores
                    if (response.data && response.data.msg) {
                      const errors = response.data.msg;

                      // Si es un objeto de errores de validación
                      if (typeof errors === 'object') {
                        const firstError = Object.values(errors)[0];
                        const errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;

                        Alerts({
                          msg: "Error",
                          title: errorMessage || "Error al solicitar recuperación",
                          code: "400",
                          type: "error",
                        });
                      } else {
                        // Si es un string directo
                        Alerts({
                          msg: "Error",
                          title: errors,
                          code: "400",
                          type: "error",
                        });
                      }
                    } else {
                      Alerts({
                        msg: "Error",
                        title: "Ocurrió un error. Intenta nuevamente más tarde.",
                        code: "500",
                        type: "error",
                      });
                    }
                  }
            }break;
        
            default:
                break;
        }
    }

    const onChange = (e) => {
        switch (e.target.name) {
            case 'email':{
                setForm({
                    ...form, 
                    [e.target.name]: e.target.value
                })
            }break;
            default:
                break;
        }
    }


    return (
        <Restaurar onChange={onChange} onClick={onClick} form={form} loading={loading}/>
    )
}

export default RestaurarController